import React, { useState, useEffect } from 'react';
import { withTheme } from 'styled-components'
import { Flex, FlexColumn } from './Container'
import { Text, Tag } from './Text'

const COUNTDOWN_SECONDS = 60

const useStyle = 1;

const CountdownTimer = ({ onTimerComplete, theme, rightText, size }) => {
    const [seconds, setSeconds] = useState(COUNTDOWN_SECONDS); // Start countdown at COUNTDOWN_SECONDS seconds

    useEffect(() => {
        let timer = null;

        if (seconds > 0) {
            // Decrement the timer every 1 second
            timer = setTimeout(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        } else {
            // Timer reaches 0, call the API and restart
            onTimerComplete(); // Call the API function
            setSeconds(COUNTDOWN_SECONDS); // Restart the countdown
        }

        // Cleanup on unmount
        return () => clearTimeout(timer);
    }, [seconds, onTimerComplete]);

    // Format time to display 00:COUNTDOWN_SECONDS style
    const formatTime = (time) => {
        const minutes = String(Math.floor(time / COUNTDOWN_SECONDS)).padStart(2, '0');
        const secs = String(time % COUNTDOWN_SECONDS).padStart(2, '0');
        return `${minutes}:${secs}`;
    };

    // Calculate percentage for the circular progress
    const progress = (seconds / COUNTDOWN_SECONDS) * 100;

    return (
        <Flex start centerHorizontally gap='4px'>
            {!rightText && <Text>{formatTime(seconds)}</Text>}
            <div style={{ position: 'relative', width: size || '50px', height: size || '50px' }}>
                <svg width={size || "50"} height={size || "50"} viewBox="0 0 50 50">
                    {/* Background circle */}
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        stroke="#E5E5E5"
                        strokeWidth="5"
                        fill="none"
                    />
                    {/* Progress circle */}
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        stroke={theme.button[`primaryBg${useStyle}`]}
                        strokeWidth="5"
                        fill="none"
                        strokeDasharray="125.6" // 2 * Math.PI * 20
                        strokeDashoffset={(125.6 * (100 - progress)) / 100}
                        strokeLinecap="round"
                        transform="rotate(-90 25 25)" // Rotate for top start
                    />
                </svg>
            </div>
            {rightText && <Text margin="0 0 0 8px" lightText>
                Refreshes in {seconds} seconds
            </Text>}
        </Flex>
    );
};

export default withTheme(CountdownTimer);
